import React, { Component } from 'react';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';

import { modelOf } from '../../../prop-types';
import Product from '../../../models/Product';
import ProductCard from '../../product/ProductCard';
import { ViewBreakpointMinWidth } from '../../../types/ViewBreakpoint';
import Slider from '../../common/Slider';
import ProductImpressions from '../../product/ProductImpressions';

const SLIDER_SETTINGS = {
  draggable: true,
  arrows: true,
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 6,
  dots: true,
  lazyLoaded: true,
  responsive: [
    {
      breakpoint: ViewBreakpointMinWidth.XXL,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: ViewBreakpointMinWidth.XL,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: ViewBreakpointMinWidth.MD,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: ViewBreakpointMinWidth.SM,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
};

@observer
class ProductSlider extends Component {
  render() {
    const { products, name, settings, cardSettings, ...rest } = this.props;

    const slides = products.map((product, index) => {
      const productCardSettings = {
        product,
        productListView: true,
        position: index + 1,
        listName: name,
        hideDescription: false,
        modelMargin: true,
        lazyLoading: false,
        ...cardSettings
      };

      return (
        <div key={product.id}>
          <ProductCard {...productCardSettings} />
        </div>
      );
    });
    const sliderSettings = settings
      ? { ...SLIDER_SETTINGS, ...settings }
      : SLIDER_SETTINGS;

    return (
      <div className="ProductSlider">
        <Slider
          {...sliderSettings}
          {...rest}
          key={products.map((product) => product.id).join(',')}
        >
          {slides}
        </Slider>
        <ProductImpressions listName={name} products={products.slice()} />
      </div>
    );
  }
}

ProductSlider.propTypes = {
  products: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(modelOf(Product)),
    PropTypes.arrayOf(modelOf(Product))
  ]).isRequired,
  name: PropTypes.string,
  settings: PropTypes.object,
  cardSettings: PropTypes.object
};

export default ProductSlider;



// WEBPACK FOOTER //
// ./src/components/slider/ProductSlider/index.jsx